import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import JwtService from "@/core/services/JwtService";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/dashboard",
    component: () => import("@/layouts/main-layout/MainLayout.vue"),
    meta: {
      middleware: "auth",
    },
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/views/Dashboard.vue"),
        meta: {
          pageTitle: "Dashboard",
          breadcrumbs: ["Dashboards"],
        },
      },
      {
        path: "/services-package",
        name: "services-package",
        component: () => import("@/views/ServicesPackage/List.vue"),
        meta: {
          pageTitle: "services package",
        },
      },
      {
        path: "/add-service",
        name: "add-service",
        component: () => import("@/views/ServicesPackage/Add.vue"),
        meta: {
          pageTitle: "add service",
        },
      },
      {
        path: "/edit-service/:id",
        name: "edit-service",
        component: () => import("@/views/ServicesPackage/Edit.vue"),
        meta: {
          pageTitle: "edit service",
        },
      },
      {
        path: "/rangePrice",
        name: "range-price",
        component: () => import("@/views/Settings/RangePrice.vue"),
        meta: {
          pageTitle: "Range Price",
        },
      },
      {
        path: "/accountsNumber",
        name: "accounts-number",
        component: () => import("@/views/AccountsNumber/List.vue"),
        meta: {
          pageTitle: "accounts number",
        },
      },
      {
        path: "/addAccount",
        name: "add-account",
        component: () => import("@/views/AccountsNumber/Add.vue"),
        meta: {
          pageTitle: "add account",
        },
      },
      {
        path: "/editAccount/:id",
        name: "edit-account",
        component: () => import("@/views/AccountsNumber/Edit.vue"),
        meta: {
          pageTitle: "edit account",
        },
      },
      {
        path: "/accountsNumberActivity",
        name: "accounts-number-activity",
        component: () => import("@/views/AccountsNumber/Activity.vue"),
        meta: {
          pageTitle: "accounts number activity",
        },
      },
      {
        path: "/accountTransactions",
        name: "account-transactions",
        component: () => import("@/views/AccountTransactions/List.vue"),
        meta: {
          pageTitle: "account transactions",
        },
      },
      {
        path: "/addAccountTransactions",
        name: "add-account-transactions",
        component: () => import("@/views/AccountTransactions/Add.vue"),
        meta: {
          pageTitle: "add account transactions",
        },
      },
      {
        path: "/editAccountTransactions/:id",
        name: "edit-account-transactions",
        component: () => import("@/views/AccountTransactions/Edit.vue"),
        meta: {
          pageTitle: "edit account transactions",
        },
      },
      {
        path: "/accountTransactionsActivity",
        name: "account-transactions-activity",
        component: () => import("@/views/AccountTransactions/Activity.vue"),
        meta: {
          pageTitle: "account transactions activity",
        },
      },
      {
        path: "/counterpartyTransaction",
        name: "counterparty-transaction",
        component: () => import("@/views/CounterpartyTransaction/List.vue"),
        meta: {
          pageTitle: "counterparty transaction",
        },
      },
      {
        path: "/counterpartyTransactionsActivity",
        name: "counterpartyTransactionsActivity",
        component: () => import("@/views/CounterpartyTransaction/Activity.vue"),
        meta: {
          pageTitle: "counterparty transaction Activity",
        },
      },
      {
        path: "/SiteSettings",
        name: "SiteSettings",
        component: () => import("@/views/Settings/SiteSettings.vue"),
        meta: {
          pageTitle: "Site Settings",
        },
      },
      {
        path: "/YoutubeChannels",
        name: "YoutubeChannels",
        component: () => import("@/views/IncomingYoutube/YoutubeChannels.vue"),
        meta: {
          pageTitle: "Youtube Channels",
        },
      },
      {
        path: "/YoutubeChannelsPayments",
        name: "YoutubeChannelsPayments",
        component: () =>
          import("@/views/IncomingYoutube/YoutubeChannelsPayments.vue"),
        meta: {
          pageTitle: "Youtube Channels Payments",
        },
      },
      {
        path: "/YoutubeInvoices",
        name: "YoutubeInvoices",
        component: () => import("@/views/IncomingYoutube/YoutubeInvoices.vue"),
        meta: {
          pageTitle: "Youtube Invoices",
        },
      },
      {
        path: "/ShowYoutubeInvoice/:id",
        name: "ShowYoutubeInvoice",
        component: () =>
          import("@/views/IncomingYoutube/ShowYoutubeInvoice.vue"),
        meta: {
          pageTitle: "Youtube Invoice",
        },
      },
      {
        path: "/AddYoutubeInvoice/:userId/:channelId",
        name: "AddYoutubeInvoice",
        component: () =>
          import("@/views/IncomingYoutube/AddYoutubeInvoice.vue"),
        meta: {
          pageTitle: "Youtube Invoice",
        },
      },
      {
        path: "/users",
        name: "list-users",
        component: () => import("@/views/Users/List.vue"),
        meta: {
          pageTitle: "users",
        },
      },
      {
        path: "/add-user",
        name: "add-user",
        component: () => import("@/views/Users/Add.vue"),
        meta: {
          pageTitle: "add user",
        },
      },
      {
        path: "/edit-user/:id",
        name: "edit-user",
        component: () => import("@/views/Users/Edit.vue"),
        meta: {
          pageTitle: "edit user",
        },
      },
      {
        path: "/edit-profile",
        name: "edit-profile",
        component: () => import("@/views/Profile/Edit.vue"),
        meta: {
          pageTitle: "edit profile",
        },
      },
      {
        path: "/discounts",
        name: "list-discounts",
        component: () => import("@/views/Discount/List.vue"),
        meta: {
          pageTitle: "list discount",
        },
      },
      {
        path: "/add-discount",
        name: "add-discount",
        component: () => import("@/views/Discount/Add.vue"),
        meta: {
          pageTitle: "add discount",
        },
      },
      {
        path: "/invoices",
        name: "invoices",
        component: () => import("@/views/Invoice/List.vue"),
        meta: {
          pageTitle: "invoices list",
        },
      },
      {
        path: "/addManualInvoice",
        name: "add-manual-invoice",
        component: () => import("@/views/Invoice/AddManualInvoice.vue"),
        meta: {
          pageTitle: "add invoice",
        },
      },
      {
        path: "/show-invoice/:id",
        name: "show-invoice",
        component: () => import("@/views/Invoice/Show.vue"),
        meta: {
          pageTitle: "show invoice",
        },
      },
      {
        path: "/logs",
        name: "logs",
        component: () => import("@/views/Logs/Purchase.vue"),
        meta: {
          pageTitle: "logs",
        },
      },
      {
        path: "/activityLogs",
        name: "activityLogs",
        component: () => import("@/views/Logs/Activity.vue"),
        meta: {
          pageTitle: "ActivityLogs",
        },
      },
      {
        path: "/tickets",
        name: "tickets",
        component: () => import("@/views/Tickets/Tickets.vue"),
        meta: {
          pageTitle: "show tickets",
        },
      },
      {
        path: "/department",
        name: "department",
        component: () => import("@/views/Tickets/Department.vue"),
        meta: {
          pageTitle: "show department",
        },
      },
      {
        path: "/edit-profile",
        name: "EditProfile",
        component: () => import("@/views/Profile/Edit.vue"),
        meta: {
          pageTitle: "Edit Profile",
        },
      },
      {
        path: "/keyword-planner",
        name: "keywordPlanner",
        component: () => import("@/views/KeywordPlanner/List.vue"),
        meta: {
          pageTitle: "keyword planner",
        },
      },
      {
        path: "/add-keyword-planner",
        name: "addKeywordPlanner",
        component: () => import("@/views/KeywordPlanner/Add.vue"),
        meta: {
          pageTitle: "add keyword planner",
        },
      },
      {
        path: "/edit-keyword-planner/:id",
        name: "editKeywordPlanner",
        component: () => import("@/views/KeywordPlanner/Edit.vue"),
        meta: {
          pageTitle: "edit keyword planner",
        },
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/layouts/AuthLayout.vue"),
    children: [
      {
        path: "/sign-in",
        name: "sign-in",
        component: () =>
          //import("@/views/crafted/authentication/basic-flow/SignIn.vue"),
          import("@/views/SignIn/SignIn.vue"),
        meta: {
          pageTitle: "Sign In",
        },
      },
      {
        path: "/sign-in-otp",
        name: "sign-in-otp",
        component: () => import("@/views/SignIn/SignInWithOtp.vue"),
        meta: {
          pageTitle: "Sign In",
        },
      },
    ],
  },
  {
    path: "/multi-step-sign-up",
    name: "multi-step-sign-up",
    component: () =>
      import("@/views/crafted/authentication/MultiStepSignUp.vue"),
    meta: {
      pageTitle: "Multi-step Sign up",
    },
  },
  {
    path: "/",
    component: () => import("@/layouts/SystemLayout.vue"),
    children: [
      {
        // the 404 route, when none of the above matches
        path: "/404",
        name: "404",
        component: () => import("@/views/crafted/authentication/Error404.vue"),
        meta: {
          pageTitle: "Error 404",
        },
      },
      {
        path: "/500",
        name: "500",
        component: () => import("@/views/crafted/authentication/Error500.vue"),
        meta: {
          pageTitle: "Error 500",
        },
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  // current page view title
  document.title = `${to.meta.pageTitle} - ${process.env.VUE_APP_NAME}`;

  // reset config to initial state
  store.commit(Mutations.RESET_LAYOUT_CONFIG);

  // verify auth token before each page change
  store.dispatch(Actions.VERIFY_AUTH, { token: JwtService.getToken() });

  // before page access check if page requires authentication
  if (to.meta.middleware == "auth") {
    if (store.getters.isUserAuthenticated) {
      next();
    } else {
      next({ name: "sign-in" });
    }
  } else {
    next();
  }

  // Scroll page to top on every route change
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
});

export default router;
